"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetForm = exports.activeFormCollaborator = exports.deactivateFormCollaborator = exports.fetchForeignFormList = exports.updateForm = exports.updateFormProps = exports.requestFormPack = exports.formErrorCode = exports.setFormConnected = exports.receiveFormData = exports.fetchForm = exports.DEFAULT_FORM_PROPS = void 0;
const form_api_1 = require("../../../../api/form_api");
const datasheet_api_1 = require("../../../../api/datasheet_api");
const config_1 = require("../../../../../../config");
const redux_batched_actions_1 = require("redux-batched-actions");
const selectors_1 = require("../../../../../../exports/store/selectors");
const datasheet_1 = require("../../../../../../modules/database/store/actions/resource/datasheet");
const actions = __importStar(require("../../../../../../modules/shared/store/action_constants"));
const catalog_tree_1 = require("../../../../../../modules/space/store/actions/catalog_tree");
const api_1 = require("../../../../../../exports/api");
const constants_1 = require("../../../../../../modules/shared/store/constants");
exports.DEFAULT_FORM_PROPS = {
    title: '',
    coverVisible: true,
    logoVisible: true,
    brandVisible: true,
    fullScreen: false,
};
function fetchForm(formId, successFn) {
    return (dispatch, getState) => {
        const state = getState();
        const { shareId, templateId, embedId } = state.pageParams;
        const formLoading = (0, selectors_1.getFormLoading)(state, formId);
        if (formLoading) {
            return;
        }
        let requestMethod = form_api_1.fetchFormPack;
        if (shareId) {
            requestMethod = () => (0, form_api_1.fetchShareFormPack)(shareId, formId);
        }
        if (templateId) {
            requestMethod = () => (0, form_api_1.fetchTemplateFormPack)(templateId, formId);
        }
        if (embedId) {
            requestMethod = () => (0, datasheet_api_1.fetchEmbedDatasheetPack)(embedId, formId);
        }
        dispatch(requestFormPack(formId));
        return requestMethod(formId)
            .then(response => {
            return Promise.resolve({ formId, response, dispatch, shareId });
        })
            .catch(e => {
            if (state.catalogTree.treeNodesMap[formId]) {
                dispatch((0, catalog_tree_1.deleteNode)({ nodeId: formId, parentId: state.catalogTree.treeNodesMap[formId].parentId }));
            }
            dispatch((0, exports.formErrorCode)(formId, config_1.StatusCode.COMMON_ERR));
            throw e;
        })
            .then((res) => {
            successFn === null || successFn === void 0 ? void 0 : successFn();
            fetchDataSuccess(res);
        });
    };
}
exports.fetchForm = fetchForm;
function fetchDataSuccess({ formId, response, dispatch }) {
    const body = response.data;
    const data = body.data;
    if (body.success && data) {
        const actions = receiveFormData(data);
        if (Array.isArray(actions)) {
            dispatch((0, redux_batched_actions_1.batchActions)(actions));
        }
        else {
            dispatch(actions);
        }
    }
    if (!body.success) {
        dispatch((0, exports.formErrorCode)(formId, body.code));
    }
}
function receiveFormData({ form, snapshot, sourceInfo, fieldPermissionMap, }) {
    const formId = form.id;
    const { meta, formProps } = snapshot;
    const currentView = meta.views.filter(view => {
        return view.id === sourceInfo.viewId;
    });
    if (!currentView.length) {
        return (0, exports.formErrorCode)(formId, config_1.StatusCode.FORM_FOREIGN_DATASHEET_NOT_EXIST);
    }
    const formState = Object.assign(Object.assign({}, form), { snapshot: {
            formProps: Object.assign(Object.assign({}, exports.DEFAULT_FORM_PROPS), formProps),
        }, sourceInfo,
        fieldPermissionMap });
    return [
        {
            type: actions.SET_FORM_DATA,
            formId,
            payload: formState,
        },
        (0, datasheet_1.receiveDataPack)({
            snapshot: { meta, recordMap: {}, datasheetId: sourceInfo.datasheetId },
            datasheet: {
                id: sourceInfo.datasheetId,
                revision: sourceInfo.datasheetRevision,
                permissions: constants_1.DEFAULT_READ_ONLY_PERMISSION,
            },
        }, { isPartOfData: true }),
    ];
}
exports.receiveFormData = receiveFormData;
const setFormConnected = (formId) => {
    return {
        type: actions.FORM_CONNECTED,
        formId,
    };
};
exports.setFormConnected = setFormConnected;
const formErrorCode = (formId, code) => {
    return {
        type: actions.FORM_ERROR_CODE,
        formId,
        payload: code,
    };
};
exports.formErrorCode = formErrorCode;
function requestFormPack(formId) {
    return {
        type: actions.SET_FORM_LOADING,
        formId,
        payload: true,
    };
}
exports.requestFormPack = requestFormPack;
const updateFormProps = (formId, formProps) => {
    return {
        type: actions.FORM_PROP_UPDATE,
        formId,
        payload: formProps,
    };
};
exports.updateFormProps = updateFormProps;
const updateForm = (formId, form) => {
    return {
        type: actions.UPDATE_FORM,
        formId,
        payload: form,
    };
};
exports.updateForm = updateForm;
function fetchForeignFormList(dstId, viewId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield api_1.Api.getRelateNodeByDstId(dstId, viewId, config_1.ConfigConstant.NodeType.FORM);
            return res.data.data;
        }
        catch (e) {
            throw new Error(e);
        }
    });
}
exports.fetchForeignFormList = fetchForeignFormList;
const deactivateFormCollaborator = (payload, resourceId) => {
    return {
        type: actions.FORM_DEACTIVATE_COLLABORATOR,
        formId: resourceId,
        payload,
    };
};
exports.deactivateFormCollaborator = deactivateFormCollaborator;
const activeFormCollaborator = (payload, resourceId) => {
    return {
        type: actions.FORM_ACTIVE_COLLABORATOR,
        formId: resourceId,
        payload,
    };
};
exports.activeFormCollaborator = activeFormCollaborator;
const resetForm = (formId) => {
    return {
        type: actions.RESET_FORM,
        formId,
    };
};
exports.resetForm = resetForm;
//# sourceMappingURL=form.js.map